//
//
//
//
//
//
//
//
//

import dayjs from "dayjs";
import dayMap from "../lib/day-map";
import { dayjsFromTime } from '../lib/dayjs-helpers';

export default {
  props: ["hours", "closed", "location"],

  methods: {
    getNextOpenDay(dayIndex) {
      // dayIndex++;

      if (dayIndex > 6) {
        dayIndex = 0;
      }

      let name = dayMap[dayIndex];
      let next = this.location.meta[`hours_${name}_open`].trim();

      if (next.length > 0) {
        return { day: name, time: next };
      }

      return this.getNextOpenDay.call(this, dayIndex + 1);
    }
  },
  computed: {
    hoursRemaining() {
      if (this.hours.isOpen && !this.location.meta.temporarily_closed) {
        return `Open <b>today</b> until ${this.hours.close
          .format("h:mm a")
          .replace(":00 ", "")}`;
      } else if(this.location.meta.temporarily_closed) {
        return `<div class="font-bold text-sm leading-none mt-1 text-red">Temporarily Closed</div>`;
      }


      // now
      let now = dayjs();

      // If we're on saturday (6), go back to day 0 (sunday)
      let next = now.day() == 6 ? 0 : now.day() + 1;
      let dayOfWeek = dayMap[now.day()];
      let dayIndex;

      let nextOpen = this.location.meta[`hours_${dayOfWeek}_open`];

      console.log(this.hours);

      if (!this.hours.isOpen || this.hours.isAfterClosing) {
        // If we're closed, get the next day's time.
        dayIndex = this.hours.isAfterClosing ? next : now.day();

        nextOpen = this.getNextOpenDay(dayIndex);
      }

      if (nextOpen) {
        let nextOpenMoment = dayjsFromTime(nextOpen.time).add(1, 'day');

        return `Opens <span class="capitalize">${
          nextOpen.day
        }</span> at ${nextOpenMoment.format("h:mm a").replace(":00 ", "")}`;
      }

      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/components/Hours.vue